module.exports = __webpack_public_path__ + "media/lemmy.3bdc11be.wav";